import { jsx as a } from "react/jsx-runtime";
import { SvgIcon as r } from "../SvgIcon.js";
const t = (o) => /* @__PURE__ */ a(r, { ...o, children: /* @__PURE__ */ a("path", { d: "M9.966 2.084a.625.625 0 0 0-.39.165l-2.708 2.5a.625.625 0 1 0 .848.918l1.659-1.531v8.989A3.115 3.115 0 0 1 6.25 16.25H2.292a.624.624 0 1 0 0 1.25H6.25a4.384 4.384 0 0 0 4.375-4.375v-8.99l1.66 1.532a.625.625 0 1 0 .847-.918l-2.708-2.5a.625.625 0 0 0-.458-.165Zm1.496 13.158a5.516 5.516 0 0 1-.633 1.137 4.353 4.353 0 0 0 2.92 1.121h3.96a.624.624 0 1 0 0-1.25h-3.96a3.076 3.076 0 0 1-2.287-1.008Z" }) });
export {
  t as Merge
};
//# sourceMappingURL=Merge.js.map
